var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1747 1.58895C12.6427 1.05626 11.9343 0.763672 11.1818 0.763672C10.43 0.763672 9.72164 1.05626 9.18964 1.58895L1.20341 9.5743C1.20341 9.5743 1.20271 9.5764 1.20131 9.5771C1.14461 9.6345 1.04801 9.78569 1.01861 9.89979L0.0211176 13.8925C-0.0390818 14.1305 0.0316176 14.3839 0.205216 14.5567L0.205916 14.5574L0.206616 14.5581C0.380215 14.7317 0.632212 14.8024 0.87091 14.7429L4.86368 13.7441C4.97778 13.7147 5.12967 13.6181 5.18637 13.5614C5.18707 13.5607 5.18917 13.5593 5.18917 13.5593L13.1754 5.57462C13.7074 5.04194 14.0007 4.33496 14 3.58178C14 2.82931 13.7074 2.12163 13.1754 1.58895H13.1747ZM8.68775 4.07317L10.6918 6.07721L4.69428 12.0746L2.6902 10.0706L8.68775 4.07317ZM1.6626 13.1015L2.0791 11.4397L3.32509 12.6864L1.6626 13.1015ZM12.1863 2.57942C12.7211 3.1149 12.7211 4.04867 12.1863 4.58415L11.683 5.08814L9.67684 3.0827L10.1815 2.57942C10.717 2.04463 11.6508 2.04393 12.1863 2.57942Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/EditPencilIcon.0e97d8051e4e8667c4bbfe5e7da691e8.svg";
export { ForwardRef as ReactComponent };